import axiosInstance from './axios-instance';
import authService from './auth-service';


export const updateCorporate = async (corporateData, corporateid) => {
  console.log('corporate update', corporateData);
  return await axiosInstance.put(
    `/user/${authService.getUserId()}/corporate/${corporateid}`,
    corporateData
  );
};

export const getCorporateForSAASAdmin= async() => {
  return await axiosInstance.get(`/user/${authService.getUserId()}/corporate`);
};


export const createProjectUser = async(userAdd,projectId) => {
  return axiosInstance.post('/user/' + authService.getUserId() + '/project/' + projectId + '/system-user', userAdd)
};

export const createUser = async(userAdd) => {
  return axiosInstance.post('/ums/user/' + authService.getUserId() + '/system-user', userAdd)
};

export const mapKitForProject = async(kitAdd) => {
  return axiosInstance.put(`/user/${authService.getUserId()}/mapKit`, kitAdd)
};

export const fetchMetaData = async () => {
  return axiosInstance.get(`/core/meta-data`);
}

export const createUserForCorporate = async (corporateId, userAdd) => {
  return axiosInstance.post(`/user/${authService.getUserId()}/corporate/${corporateId}/system-user`,userAdd);
};

export const updateUserForCorporate = async(corporateId, userId, userData) => {
  return axiosInstance.put(`/user/${authService.getUserId()}/corporate/${corporateId}/system-user/${userId}`,userData);
}


export const updateUser = async(projectId, userId, userData) => {
  return axiosInstance.put(`/user/${authService.getUserId()}/project/${projectId}/system-user/${userId}`,userData);
}

export const updateUserForKit = async(kitId, userId, userData) => {
  return axiosInstance.put(`/user/${authService.getUserId()}/kit/${kitId}/system-user/${userId}`, userData);
}

export const getAlertSettingsForKitUser = async (kitId, systemUserId) => {
  return axiosInstance.get(
    `/user/${authService.getUserId()}/system-user/${systemUserId}/kit/${encodeURIComponent(kitId)}/alert`
  );
}

export const updateAlertSettingsForKitUser = async (kitId, systemUserId, alertPayload) => {
  return axiosInstance.put(
    `/user/${authService.getUserId()}/system-user/${systemUserId}/kit/${encodeURIComponent(kitId)}/alert`,
    alertPayload
  );
}

export const deleteCorporateUser = async(corporateId, userId) => {
  return axiosInstance.delete(`/user/${authService.getUserId()}/corporate/${corporateId}/system-user/${userId}`);
}

export const deleteUser = async(projectId, userId) => {
  return axiosInstance.delete(`/user/${authService.getUserId()}/project/${projectId}/system-user/${userId}`);
}

export const resendRegistrationMail = async (value) => {
  return axiosInstance.post(`/resend-key`, value);
};

export const createUserForKit = async(kitId, userData) => {
  return axiosInstance.post(`/user/${authService.getUserId()}/kit/${kitId}/system-user`, userData);
}

export const deleteUserForKit = async(kitId, userId) => {
  return axiosInstance.delete(`/user/${authService.getUserId()}/kit/${kitId}/system-user/${userId}`);
}

export const getDevicesOfProject = async(projectId) => {
  return axiosInstance.get(`/user/${authService.getUserId()}/project/${projectId}/kit`);
}

export const createReport = async (reportData) => {
  return axiosInstance.post(`/user/${authService.getUserId()}/report`, reportData);
};

export const fetchReports = async (projectId) => {
  const userId = authService.getUserId();
  return axiosInstance.get(`/user/${authService.getUserId()}/project/${projectId}/recent-report`);
};

export const getNotificationForUser = async (offset) => {
  return axiosInstance.get(
    `/user/${authService.getUserId()}/notification/size/10/index/${offset}`,
  );
};

export const getNotificationOfProject = async (projectId, offset = 0) => {
  return axiosInstance.get(
    `/user/${authService.getUserId()}/project/${projectId}/notification/size/10/index/${offset}`,
  );
};

export const changePassword = async (value) => {
    const res = await axiosInstance.post(`/change-password`, value);
    return res;
  }

export const fetchUserConfig = async () => {
  return axiosInstance.get(`/user/${authService.getUserId()}/data`);
}

export const getKitsOfProjectForUser=async(userId, projectId)=>{
    return axiosInstance.get('/user/' + authService.getUserId() + '/system-user/' + userId + '/kit?project=' + projectId)
  }
export const getKitsForKitUsers = async() => {
    return axiosInstance.get('/user/' + authService.getUserId() + '/kit')
  }
export const getExistingProjectUsers=async(corporateId, projectId)=>{
    return axiosInstance.get('/user/' + authService.getUserId() + '/corporate/' + corporateId + '/project/' + projectId)
  }

export const addExistingUser=async( projectId,userIds)=>{
    return axiosInstance.post( '/user/' + authService.getUserId() + '/project/' + projectId,
      userIds)
  }
  export const getAcknowledgement=async( emailAckId)=>{
    return axiosInstance.get( `/emailAck/${emailAckId}/get-email-ack`)
  }
    export const getUser=async( IdOfUserToGet)=>{
    return axiosInstance.get( `/ums/user/${authService.getUserId()}/system-user/${IdOfUserToGet}`)
  }
  

  
